/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackprice2Inputs */

const en_artifactpackprice2 = /** @type {(inputs: Artifactpackprice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€149`)
};

const pt_artifactpackprice2 = /** @type {(inputs: Artifactpackprice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€149`)
};

/**
* | output |
* | --- |
* | "€149" |
*
* @param {Artifactpackprice2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackprice2 = /** @type {((inputs?: Artifactpackprice2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackprice2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackprice2(inputs)
	return pt_artifactpackprice2(inputs)
});
export { artifactpackprice2 as "artifactPackPrice" }